const CONTENT = {
  ENTER_EMAIL: 0,
  REVIEW_DETAILS: 1,
  ACCEPT_CONFIRMATION: 2,
  REJECT_CONFIRMATION: 3,
  VALIDATE_DELIVERABLE_ADDRESS: 4,
};

export default CONTENT;
